import React from 'react';
import { Grid, FormLabel, TextField, FormHelperText } from '@mui/material';
import { DEAL_OVERVIEW, YEAR_FOLDER } from '../../CreateNewBusinessForm/validationSchema';
import FolderNameField from '../../CreateNewBusinessForm/Fields/FolderNameField';
import { YearFolderSelect } from '@/components/selects/YearFolderSelect';
import { useLocation } from 'react-router-dom';
import { paths } from '@/app/routes';
import { YEAR_FOLDER_HELP_TEXT, DEAL_OVERVIEW_HELP_TEXT } from '@/utils/helperText';
import { useFormikContext } from 'formik';

const DealNaming = ({
	// values,
	// isSubmitting,
	dealName = 'Deal name',
	// errors = {},
	// setFieldValue,
	// getFieldProps,
	// touched,
	...formik
}) => {
	const hasFormik = Object.keys(formik).length > 0;
	const { values, isSubmitting, errors, setFieldValue, getFieldProps, touched } = hasFormik
		? formik
		: useFormikContext();

	const location = useLocation();
	const isClaims = location.pathname.includes(paths.createClaim);
	const isDebtor = location.pathname.includes(paths.createDebtor);

	return (
		<>
			<Grid size={{ md: 8 }}>
				<FolderNameField
					{...{
						disabled: isSubmitting,
						dealName,
					}}
				/>
			</Grid>
			<Grid size={{ md: 4 }}>
				<FormLabel
					htmlFor={YEAR_FOLDER}
					required
					error={Boolean(touched?.[YEAR_FOLDER] && errors?.[YEAR_FOLDER])}
				>
					{'Year folder'}
				</FormLabel>

				<YearFolderSelect
					name={YEAR_FOLDER}
					value={values[YEAR_FOLDER]}
					disabled={isSubmitting}
					onChange={(option) => setFieldValue(YEAR_FOLDER, option)}
					error={Boolean(touched?.[YEAR_FOLDER] && errors?.[YEAR_FOLDER])}
				/>

				{touched?.[YEAR_FOLDER] && errors?.[YEAR_FOLDER] && (
					<FormHelperText error>{errors[YEAR_FOLDER]}</FormHelperText>
				)}

				<FormHelperText>{YEAR_FOLDER_HELP_TEXT}</FormHelperText>
			</Grid>

			{!isClaims && !isDebtor && (
				<Grid size={{ md: 12 }}>
					<FormLabel>{'Deal overview'}</FormLabel>
					<TextField
						fullWidth
						name={DEAL_OVERVIEW}
						multiline
						rows={3}
						{...getFieldProps(DEAL_OVERVIEW)}
						disabled={isSubmitting}
					/>
					<FormHelperText>{DEAL_OVERVIEW_HELP_TEXT}</FormHelperText>
				</Grid>
			)}
		</>
	);
};

export default DealNaming;
